﻿import { Controller } from "@hotwired/stimulus";
import "toastr";

export default class extends Controller {
    static get values() {
        return {
            membershipUrl: String,
            referralCode: String,
            linkCopiedMessage: String,
            codeCopiedMessage: String
        }
    }

    copyLink() {
        navigator.clipboard.writeText(this.membershipUrlValue);
        toastr.success(this.linkCopiedMessageValue);
    }

    copyCode() {
        navigator.clipboard.writeText(this.referralCodeValue);
        toastr.success(this.codeCopiedMessageValue);
    }
}
